export default __webpack_public_path__ + "static/media/loader.45df2d82.gif";